import React, { useState, useEffect } from 'react';
import { navigationData } from '../data/mock';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      const headerHeight = 310;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${
        isScrolled
          ? 'shadow-md'
          : ''
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Logo and Navigation Row */}
        <div className="flex items-center justify-between py-6">
          {/* Logo - Left */}
          <a
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('#home');
            }}
            className="flex items-center group"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_c37f8639-afef-44f7-8aa2-b06d370dacb2/artifacts/5w4vojpf_C%20Clark%20logo.jpg"
              alt="Christina Clark Consulting"
              className="h-72 w-auto transition-transform group-hover:scale-105"
            />
          </a>

          {/* Desktop Navigation - Right */}
          <nav className="hidden md:flex items-center gap-8">
            {navigationData.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(item.href);
                }}
                className="text-sm font-medium transition-colors text-slate-600 hover:text-[#6b2d7b]"
              >
                {item.label}
              </a>
            ))}
            <Button
              onClick={() => scrollToSection('#contact')}
              className="bg-[#7ed321] hover:bg-[#6bc11a] text-[#2d1b38] font-semibold px-6"
            >
              Get in Touch
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-slate-100 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-[#6b2d7b]" />
            ) : (
              <Menu className="w-6 h-6 text-[#6b2d7b]" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            isMobileMenuOpen ? 'max-h-80 pb-6' : 'max-h-0'
          }`}
        >
          <nav className="flex flex-col gap-4 bg-slate-50 rounded-xl p-4 shadow-lg">
            {navigationData.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(item.href);
                }}
                className="text-slate-600 font-medium py-2 px-4 rounded-lg hover:bg-[#6b2d7b]/10 hover:text-[#6b2d7b] transition-colors"
              >
                {item.label}
              </a>
            ))}
            <Button
              onClick={() => scrollToSection('#contact')}
              className="bg-[#7ed321] hover:bg-[#6bc11a] text-[#2d1b38] font-semibold mt-2"
            >
              Get in Touch
            </Button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
